import { createSlice } from "@reduxjs/toolkit";
import {
  getFinanceAtc,
  getFinancePublic,
  getFinancePublicFilter,
} from "../apiActions/financeAction";

export type Finance = {
  id: string;
  created_at: string;
  atc_name: string;
  exam_name: string;
  invoice_number: string;
  request_id: string;
  payment_id: string;
  requested_vouchers: number;
  used_vouchers: number;
};

interface InitialState {
  loading: {
    getRequest: boolean;
    createExam: boolean;
    updateExam: boolean;
    deleteExam: boolean;
  };
  deleteLoading: boolean;
  error: null | string;
  financeAtc: Finance[];
  financePublic: Finance[];
  modal: boolean;
  total_requested_vouchers: number;
  total_used_vouchers: number;
}

const initialState: InitialState = {
  financeAtc: [],
  financePublic: [],
  total_requested_vouchers: 0,
  total_used_vouchers: 0,
  error: null,
  loading: {
    getRequest: false,
    updateExam: false,
    deleteExam: false,
    createExam: false,
  },
  deleteLoading: false,
  modal: false,
};

const financeSlice = createSlice({
  name: "request",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFinanceAtc.pending, (state: InitialState) => {
        state.loading.getRequest = true;
        state.error = null;
      })
      .addCase(getFinanceAtc.fulfilled, (state: InitialState, action) => {
        state.loading.getRequest = false;
        state.error = null;
        state.financeAtc = action.payload.data;
        state.total_requested_vouchers =
          action.payload.total_requested_vouchers;
        state.total_used_vouchers = action.payload.total_used_vouchers;
        state.modal = false;
      })
      .addCase(getFinanceAtc.rejected, (state: InitialState, action) => {
        state.loading.getRequest = false;
      })
      .addCase(getFinancePublicFilter.pending, (state: InitialState) => {
        state.loading.getRequest = true;
        state.error = null;
      })
      .addCase(
        getFinancePublicFilter.fulfilled,
        (state: InitialState, action) => {
          state.loading.getRequest = false;
          state.error = null;
          state.financeAtc = action.payload.data;
          state.total_requested_vouchers =
            action.payload.total_requested_vouchers;
          state.total_used_vouchers = action.payload.total_used_vouchers;
          state.modal = false;
        }
      )
      .addCase(
        getFinancePublicFilter.rejected,
        (state: InitialState, action) => {
          state.loading.getRequest = false;
        }
      )
      .addCase(getFinancePublic.pending, (state: InitialState) => {
        state.loading.getRequest = true;
        state.error = null;
      })
      .addCase(getFinancePublic.fulfilled, (state: InitialState, action) => {
        state.loading.getRequest = false;
        state.error = null;
        state.financePublic = action.payload.data;
        state.total_requested_vouchers =
          action.payload.total_requested_vouchers;
        state.total_used_vouchers = action.payload.total_used_vouchers;
      })
      .addCase(getFinancePublic.rejected, (state: InitialState, action) => {
        state.loading.getRequest = false;
      });
  },
});

// export const {} = financeSlice.actions;
export default financeSlice.reducer;
